var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptydoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F3F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9697 26.4697C26.2626 26.1768 26.7374 26.1768 27.0303 26.4697L28.5303 27.9697C28.8232 28.2626 28.8232 28.7374 28.5303 29.0303C28.2374 29.3232 27.7626 29.3232 27.4697 29.0303L25.9697 27.5303C25.6768 27.2374 25.6768 26.7626 25.9697 26.4697Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 22.25C22.7574 22.25 21.75 23.2574 21.75 24.5C21.75 25.7426 22.7574 26.75 24 26.75C24.6226 26.75 25.1849 26.4981 25.5931 26.0889C25.9998 25.6811 26.25 25.1205 26.25 24.5C26.25 23.2574 25.2426 22.25 24 22.25ZM20.25 24.5C20.25 22.4289 21.9289 20.75 24 20.75C26.0711 20.75 27.75 22.4289 27.75 24.5C27.75 25.5335 27.3309 26.4706 26.6552 27.1481C25.9771 27.828 25.0371 28.25 24 28.25C21.9289 28.25 20.25 26.5711 20.25 24.5Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 14.75V33.25H31.75V17.8107L28.6893 14.75H17.25ZM15.75 14.6C15.75 13.8544 16.3544 13.25 17.1 13.25H28.7515C29.1095 13.25 29.4529 13.3922 29.7061 13.6454L32.8546 16.7939C33.1078 17.0471 33.25 17.3905 33.25 17.7485V33.4C33.25 34.1456 32.6456 34.75 31.9 34.75H17.1C16.3544 34.75 15.75 34.1456 15.75 33.4V14.6Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 13.25C28.9142 13.25 29.25 13.5858 29.25 14V17.25H32.5C32.9142 17.25 33.25 17.5858 33.25 18C33.25 18.4142 32.9142 18.75 32.5 18.75H29.1C28.3544 18.75 27.75 18.1456 27.75 17.4V14C27.75 13.5858 28.0858 13.25 28.5 13.25Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptydoc);
export default __webpack_public_path__ + "static/media/emptydoc.dfbc258a074674c8890327194c0e0297.svg";
export { ForwardRef as ReactComponent };